"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SystemNotification = void 0;
const app_module_1 = require("./app.module");
const token_service_1 = require("./token.service");
class SystemNotification {
    fetch(_a) {
        return __awaiter(this, arguments, void 0, function* ({ type = 'systemnotification' }) {
            let http = app_module_1.AppModule.injector.get(token_service_1.TokenService);
            return new Promise((resolve, reject) => {
                http.get(`/${type}/${this.id}`)
                    .toPromise()
                    .then(response => response.json())
                    .then(response => {
                    let notification = new SystemNotification(response);
                    resolve(notification);
                })
                    .catch(err => {
                    reject(err);
                });
            });
        });
    }
    static initCollection(notifications) {
        if (Array.isArray(notifications)) {
            return notifications.map(notification => { return new SystemNotification(notification); });
        }
        return [new SystemNotification(notifications)];
    }
    constructor(params) {
        Object.assign(this, params);
    }
    isTemporary() {
        return this.type === 'temporary';
    }
    isStateDisplay() {
        return this.state === 'display';
    }
    targetsCurrentUser(currentUser) {
        return this.user && this.user === currentUser.id;
    }
    targetsCurrentOrganization(currentUser) {
        return this.org && currentUser.organization && this.org === currentUser.organization.id;
    }
    isStarted() {
        if (!this.startTime)
            return false;
        let now = moment();
        let startTime = moment(this.startTime);
        return (startTime.month() === now.month() && startTime.day() === now.day());
    }
    isEnded() {
        if (!this.endTime)
            return false;
        let now = moment();
        let endTime = moment(this.endTime);
        return endTime.diff(now) < 0;
    }
    isActive() {
        return this.isStarted() && !this.isEnded();
    }
    displayable(currentUser) {
        // If the notification does not target the current user or the current organization, return false
        if (!this.targetsCurrentUser(currentUser) && !this.targetsCurrentOrganization(currentUser)) {
            return false;
        }
        // If the notification is temporary and is active, return true
        if (this.isTemporary() && this.isActive()) {
            return true;
        }
        // For all other situations
        return true;
    }
}
exports.SystemNotification = SystemNotification;
//# sourceMappingURL=system-notification.js.map